const SubscriptionStatusTypes = {
  Independent: "independent",
  IncorrectSchoolEmail: "incorrect school email",
  School: "school",
  NotSubscribed: "no subscription",
};

const MARKING_MODES = {
  HOLISTIC: "HOLISTIC",
  ANALYTIC: "ANALYTIC",
};

const DEFAULT_PREFS = {
  allow_spelling_assistance: true,
  allow_copy_paste: true,
  hide_marks: false,
  marking_mode: MARKING_MODES.ANALYTIC,
  auto_release_marks: false,
  notify_students_by_email_of_feedback: false,
};

export { SubscriptionStatusTypes, MARKING_MODES, DEFAULT_PREFS };
